import gridNames from 'common/gridNames';
import foxGridReducer from 'FoxReact/FoxGrid/reducer';

const administrationNotificationTemplates = foxGridReducer(
    gridNames.administrationNotificationTemplates
);

export default administrationNotificationTemplates;
